import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, ShieldCheck } from "lucide-react";
import * as ella from "@/lib/ellaApi";
import { useSeo } from "@/lib/seo";

const FALLBACK = `Ellafroze menghormati dan melindungi data pribadi pengguna.

Data yang dapat kami kumpulkan meliputi:
- nama;
- nomor telepon;
- alamat email;
- alamat pengiriman;
- data transaksi.

Data digunakan untuk:
- memproses pesanan;
- pengiriman produk;
- layanan pelanggan;
- informasi promosi dan pengembangan layanan.

Ellafroze berkomitmen menjaga keamanan data pribadi pengguna dan tidak membagikan data kepada pihak lain tanpa dasar yang sah sesuai ketentuan peraturan perundang-undangan.

Pengguna memiliki hak untuk:
- meminta akses data;
- memperbaiki data;
- meminta penghapusan data sesuai ketentuan yang berlaku.

Dengan menggunakan layanan Ellafroze, pengguna menyetujui pemrosesan data pribadi sesuai Kebijakan Privasi ini.

Kontak: Email: ellafroze.master@gmail.com`;

export default function PrivacyPolicyPage() {
  const nav = useNavigate();
  const [content, setContent] = useState({ title: "Kebijakan Privasi Ellafroze", version: "", body: FALLBACK });

  useSeo({
    title: "Kebijakan Privasi",
    description: "Kebijakan Privasi Ellafroze — perlindungan data pelanggan sesuai peraturan perundang-undangan Republik Indonesia.",
    path: "/privacy-policy",
  });

  useEffect(() => {
    ella.getActiveTerms().then((res) => {
      if (res.status && res.data) {
        const d = res.data;
        setContent({
          title: d.Title || "Kebijakan Privasi Ellafroze",
          version: d.Version || "",
          body: d.Content || FALLBACK,
        });
      }
    }).catch(() => {});
  }, []);

  return (
    <div className="pb-24">
      <div className="px-4 py-3 flex items-center gap-3 sticky top-[60px] bg-white z-30 border-b border-gray-100">
        <button onClick={() => nav(-1)} className="p-1 -ml-1 hover:bg-gray-100 rounded-full" data-testid="back-button"><ChevronLeft className="w-5 h-5" /></button>
        <h1 className="font-display text-lg font-bold text-gray-900">Perlindungan Data</h1>
      </div>

      <div className="p-4">
        <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-4 mb-4 flex gap-3 items-center">
          <div className="w-12 h-12 rounded-xl bg-white flex items-center justify-center shrink-0">
            <ShieldCheck className="w-6 h-6 text-[#D32F2F]" />
          </div>
          <div>
            <h2 className="font-display font-bold text-gray-900" data-testid="privacy-title">{content.title}</h2>
            {content.version && <p className="text-xs text-gray-500 mt-0.5">Versi: {content.version}</p>}
          </div>
        </div>
        <div className="bg-white rounded-2xl border border-gray-100 p-4">
          <pre className="whitespace-pre-wrap font-sans text-sm text-gray-700 leading-relaxed" data-testid="privacy-body">{content.body}</pre>
        </div>
        <p className="text-xs text-gray-400 text-center mt-4">© Ella Froze • Semua data dikelola sesuai peraturan perundang-undangan yang berlaku di Republik Indonesia.</p>
      </div>
    </div>
  );
}
